import {combineReducers} from '@reduxjs/toolkit';
import airportsList from './airports-list.slice';
import createAirport from './create-airport.slice';
import deleteAirport from './delete-airport.slice';
import updateAirport from './update-airport.slice';
import timezoneList from './timezone-list.slice';
import updateAirportStatus from './update-airport-status.slice';

const reducer = combineReducers({
  airportsList,
  createAirport,
  deleteAirport,
  updateAirport,
  updateAirportStatus,
  timezoneList
});

export default reducer;